export default "__VITE_ASSET__SJGuPwAw__"